import React, {Component, Fragment} from 'react';
import {Button, CardTitle} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../constants/configs';
import {i18nizeDate, numberWithCommas} from '../../../helpers/Utils';
import ReactTableTextFilter from '../../../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../../../components/ReactTableSelectFilter";
import ModalManager from "../../../components/modal/ModalManager";
import LoaderButton from "../../../components/LoaderButton";
import UserInfo from "../../../components/UserInfo";
import {keyBy, mapValues, omit} from 'lodash';
import Rbac from "../../../components/Rbac";
import Api from '../../../services/Api';
import ReactTable from 'react-table';

class ExchangeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      giftCards: [],
      pages: -1,
      loading: false,
      updating: {},
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderUserInfo = this.renderUserInfo(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/giftCards',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            creatorType: 'ADMIN',
          }
        }
      );
      this.setState({
        giftCards: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressRefund = (id, code, values) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Re-fund'),
      body: t('Are you sure you want to re-fund gift card with code {{code}} ?', {
        code,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.updateGiftCard(id, values);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  updateGiftCard = async (id, values) => {
    this.setState(({updating}) => ({
      updating: {
        ...updating,
        [id]: true,
      },
    }));
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/giftCards/${id}`, values);
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState(({updating}) => ({
        updating: {
          ...updating,
          [id]: false,
        },
      }));
    }
  }

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 180,
    },
    {
      Header: t('Gift Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 120,
    },
    {
      Header: t('Count'),
      accessor: 'expireCriteria.numUsage',
      Cell: props => {
        if (props.original.recipient.type !== "USER") {
          return <span>{numberWithCommas(props.value)}</span>
        }
        return <span>1</span>;
      },
      width: 80,
    },
    {
      Header: t('Type'),
      accessor: 'recipient.type',
      width: 120,
    },
    {
      Header: t('Gifts'),
      accessor: 'gifts',
      Cell: props => {
        if (props.value.length > 1) {
          return (
            <ul dir="ltr" style={{marginBottom: 0}}>
              {props.value.map(item => (
                <li key={item.token} style={{textAlign: 'left'}}>{`${numberWithCommas(Number(item.amount))} ${item.token}`}</li>
              ))}
            </ul>
          );
        }
        return <div dir="ltr" className="text-left pr-4">{`${numberWithCommas(Number(props.value[0].amount))} ${props.value[0].token}`}</div>
      },
      width: 160,
    },
    {
      Header: t('Creator'),
      accessor: 'creator.value',
      Cell: props => {
        return (
          <UserInfo
            textColor="text-dark"
            label={t('Admin')}
            id={props.value}
            type="ADMIN"
          />
        );
      },
      width: 80,
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        if (type === "USER" || type === "UNKNOWN_USER") {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
              label={type === "UNKNOWN_USER" ? t('Not registered user') : t('User')}
              textColor="text-success"
              type={type}
              id={value}
            />
          );
        }
        return <span>{value || "ALL_USERS"}</span>;
      },
      width: 140,
    },
    {
      Header: t('Creditor'),
      accessor: 'creditor',
      Cell: props => {
        if (props.value) {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + props.value);}}
              textColor="text-primary"
              label={t('Creditor')}
              id={props.value}
              type="USER"
            />
          );
        }
        return null;
      },
      width: 120,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      width: 120,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 130,
    },
    {
      Header: t('Expiration Date'),
      accessor: 'expireCriteria.time',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "-------"}</span>,
      width: 130,
    },
    {
      Header: t('Actions'),
      accessor: 'status',
      width: 220,
      Cell: props => <div className="d-flex flex-row align-items-center">
        {props.value !== "REFUNDED" &&
          <Rbac permission='update_gift'>
            <LoaderButton
              outline
              size="sm"
              color="danger"
              loading={!!this.state.updating[props.original.id]}
              onClick={async () => {
                await this.onPressRefund(
                  props.original.id,
                  props.original.code,
                  {status: 'REFUNDED'}
                );
              }}
              className="text-center mr-2">
              {t('Re-fund')}
            </LoaderButton>
          </Rbac>
        }
        {props.original.recipient.type === "GROUP" &&
          <Rbac permission='view_gift-stats'>
            <Button
              outline
              size="sm"
              color="success"
              onClick={() => {
                this.props.history.push('/dashboard/giftCards/' + props.original.id, {
                  count: props.original.expireCriteria.numUsage
                });
              }}
              className="text-center">
              {t('View Stats')}
            </Button>
          </Rbac>
        }
      </div>,
      show: Rbac.hasPermission('update_gift') || Rbac.hasPermission('view_gift-stats'),
    },
  ];

  renderUserInfo = props => {
    const {t} = this.props;
    if (props.value) {
      return (
        <UserInfo
          onClick={() => {this.props.history.push('/dashboard/users/' + props.value);}}
          textColor="text-success"
          label={t('User')}
          id={props.value}
          type="USER"
        />
      );
    }
    return null;
  };

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CREATED', label: t('CREATED')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'REFUNDED', label: t('REFUNDED')},
      {value: 'EXPIRED', label: t('EXPIRED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  onPressCreate = () => {
    this.props.history.push('/dashboard/giftCards/create');
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center mt-4">
          <Rbac permission='create_gift'>
            <Button onClick={this.onPressCreate}>
              <i className="simple-icon-plus add-reply-icon"/>
              <span className="mx-1">{t('Create Gift Card')}</span>
            </Button>
          </Rbac>
        </CardTitle>
        <ReactTable
          manual
          ref={el => {this.table = el;}}
          className="-highlight"
          data={this.state.giftCards}
          pages={this.state.pages}
          loading={this.state.loading}
          onFetchData={this.fetchData}
          columns={this.getColumns(t)}
          style={{width: '100%'}}
          defaultPageSize={25}
          sortable={false}
          resizable={true}
          {...reactTableText}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(ExchangeList);
